import type { TmWrappers } from '@/wrappers'

export const subAccountsImportDetailsFailedModalId: TmWrappers = 'subAccountsImportDetailsFailedModal'
